/* eslint-disable max-len */
import React from 'react';

import { borders } from '^/constants/commonStyles';
import { CURRENCY_CODE_KEYS } from '^/constants/currencyCode.constants';
import { RawReservationDetailExtraChange } from '^/types/ReservationDetailed/RawReservationDetailed';
import { formatKRWWonAmount } from '^/util/formatKRWWonAmount';
import { ExtraChargeDisplayCurrency } from '^/pages/ReservationDetail/extraChargeDisplay';

export const AdditionFees: React.FC<{
  extra_charge: RawReservationDetailExtraChange;
  onSiteCurrency: CURRENCY_CODE_KEYS;
  displayCurrency?: ExtraChargeDisplayCurrency;
  stylesOverride?: {
    titleText?: string;
    totalText?: string;
    itemTitleText?: string;
    itemTotalText?: string;
  };
}> = ({ extra_charge, onSiteCurrency, displayCurrency = 'foreign', stylesOverride }) => {
  const isKrwDisplay = displayCurrency === 'krw';
  const currencyLabel = isKrwDisplay ? '원' : onSiteCurrency;
  const totalAmount = isKrwDisplay
    ? extra_charge.additional_rate_amount ?? extra_charge.additional_amount
    : extra_charge.additional_amount;
  const getItemAmount = (item: RawReservationDetailExtraChange['extra_charge_detail'][number]) => {
    if (!isKrwDisplay) return item.price;
    return item.price_krw ?? item.price;
  };
  const getItemTotal = (item: RawReservationDetailExtraChange['extra_charge_detail'][number]) => {
    const itemAmount = Number(getItemAmount(item)) || 0;
    return itemAmount;
  };
  const formatAmount = (value?: number | string | null) => {
    if (isKrwDisplay) return formatKRWWonAmount(value);
    if (value === null || value === undefined) return null;
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    const rawValue = numericValue.toFixed(2);
    return rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  return (
    <div className="flex flex-col gap-2">
      {!isKrwDisplay && (
        <div className="flex flex-row justify-between">
          <p className={[stylesOverride?.titleText ?? 'text-big tablet:text-semilarge'].join(' ')}>
            추가 요금
          </p>
          <p className={[stylesOverride?.totalText ?? 'font-bold text-semilarge'].join(' ')}>
            {formatAmount(totalAmount)} {currencyLabel}
          </p>
        </div>
      )}
      {extra_charge.extra_charge_detail.map((item, index) => (
        <div key={index} className="flex flex-row justify-between">
          <p
            className={[
              stylesOverride?.itemTitleText ??
                'text-default font-light text-trimo-gray tablet:text-default',
            ].join(' ')}
          >
            {`${item.name} (${item.quantity})`}
          </p>
          <p
            className={[
              stylesOverride?.itemTotalText ??
                'text-default font-light text-trimo-gray tablet:text-default',
            ].join(' ')}
          >
            {formatAmount(getItemTotal(item))} {currencyLabel}
          </p>
        </div>
      ))}
      {extra_charge.dropFee > 0 && (
        <div className="flex flex-row justify-between">
          <p className="text-default font-light text-trimo-gray tablet:text-default">Drop fee</p>
          <p className="text-default font-light text-trimo-gray tablet:text-default">
            {formatAmount(extra_charge.dropFee)} {currencyLabel}
          </p>
        </div>
      )}
      {extra_charge.etc_amount > 0 && (
        <div className="flex flex-row justify-between">
          <p className="text-default font-light text-trimo-gray tablet:text-default">
            기타 (세금 등)
          </p>
          <p className="text-default font-light text-trimo-gray tablet:text-default">
            {formatAmount(extra_charge.etc_amount)} {currencyLabel}
          </p>
        </div>
      )}
    </div>
  );
};
